import './admin-course-card-v2.scss';
import '../../../../../../../components/UI/Cards/Plar/ProgramAdminCard/program-admin-card.scss';
import ButtonKMQ from "../../../../../../../components/UI/Button/ButtonKMQ";
import PaymentChiclet from "../../../../../../../components/UI/Chiclets/PaymentChiclet/PaymentChiclet";
import SkillChiclet from "../../../../../../../components/UI/Chiclets/SkillChiclet/SkillChiclet";
import {
  cardTypeToChicletType
} from "../../../../../../../components/UI/Cards/Plar/ProgramAdminCard/ProgramAdminCardStatus";
import ProgressChiclet from '../../../../../../../components/UI/Chiclets/ProgressChiclet/ProgressChiclet';
import {ChicletTypes} from "../../../../../../../constants/ui/types/ChicletTypes";

interface AdminCourseCardProps {
  title: string,
  buttonText: string,
  code: string,
  cplEligible: boolean,
  assignedTo?: string,
  isPaid: boolean,
  matchingScore: string,
  onClick: () => void,
  approved?: boolean
}

const AdminCourseCard = (props: AdminCourseCardProps) => {
  const {
    title,
    onClick,
    buttonText,
    code,
    cplEligible,
    assignedTo,
    matchingScore,
    isPaid,
    approved
  } = props;

  return <div className={`program-admin-card admin-course-card-v2`}>

    {
      <div className={'program-admin-card-subtitle'}>
        <span>
          {code}
        </span>
        {
          cplEligible
            ? <span>
              <span className={'program-admin-card-subtitle-divider'}>
              |
              </span>
              <span>
                CPL Eligible
              </span>
            </span>
            : null
        }

      </div>
    }

    <div className={'program-admin-card-title'}>
      {title}
    </div>

    <div className={`plar-card-status`}>
      {isPaid
        ? <PaymentChiclet text={'Paid'}/>
        : null
      }
      {
        approved !== null && approved !== undefined
          ? <ProgressChiclet
            type={approved ? ChicletTypes.Completed : ChicletTypes.Overdue}
            text={approved ? 'Approved' : 'Rejected'}
          />
          : null
      }
      <SkillChiclet text={matchingScore}/>
    </div>

    <div className={'program-admin-card-footer'}>
      <span className={'program-admin-card-footer-assigned-to'}>
        Assigned to: {assignedTo ? assignedTo : "N/A"}
      </span>
      <ButtonKMQ onClick={onClick}>
        {buttonText}
      </ButtonKMQ>
    </div>
  </div>
}

export default AdminCourseCard;